import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DocumentNameWrapper from '../../../Common/document-name-box.js';
import CustomUpload from '../../../Common/custom-upload.js';
import PreviewUploadDocument from '../../NewEsign/preview-upload-document-new.js';
import {
	addCkAttachments,
	addEsignAttachments,
	selecteFileStatus
} from '../../../../Store/Redux/file-list-slice.js';
import { useQueryParameters } from '../../../Common/use-query-parameters.js';
import {
	addCKattachmentEsignAPI,
	addCkAttachmentApi
} from '../../../../Services/api-config.js';

function CKEditorAttachments() {
	const theme = useTheme();
	const canvasRef = useRef();
	const dispatch = useDispatch();

	const attachedfiles = useSelector((state) => state.fileList.ckAttach);
	const selectedFile = useSelector((state) => state.fileList.selectedFile);

	const { documentID } = useSelector((state) => state.newesign);

	const acceptedFileTypes = [
		'.pdf',
		'application/pdf',
		'image/png',
		'image/jpg',
		'image/jpeg'
	];
	const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes
	const [openPDF, setOpenPDF] = useState(false);
	const isMobile = useMediaQuery('(max-width:768px)');
	const { getParameter } = useQueryParameters();
	const createmode = getParameter('createmode');
	const fileId = getParameter('fileId');
	const [dropzoneEnabled, setDropzoneEnabled] = useState(true);
	const [errorMessage, setErrorMessage] = useState('');

	const handleOpenContent = (file) => {
		// Only for pdf
		dispatch(selecteFileStatus(file));
		setOpenPDF(true);
	};

	useEffect(() => {
		if (attachedfiles.length === 5) {
			setErrorMessage('Max file attached');
			setDropzoneEnabled(false);
		}
	}, [attachedfiles]);

	const handleAttachmentSave = async (payload) => {
		console.log('payloadpayload', payload);
		const mapPayload = payload.map((item) => ({
			attachmentFile: item.dataUrl,
			attachmentType: item.type === 'application/pdf' ? 'pdf' : 'image',
			attachmentName: item.name
		}));

		try {
			if (createmode === 'true') {
				const resp = await addCkAttachmentApi(fileId, mapPayload);

				for (const [index, serverPayload] of payload.entries()) {
					const typeString = serverPayload.dataUrl.split(';')[0];
					const attachment = {
						type: serverPayload.type,
						typeString,
						dataUrl: serverPayload.dataUrl,
						name: serverPayload.name,
						id: resp.attachmentId[index],
						enableDelete: true
					};
					dispatch(addCkAttachments(attachment));
				}
			}

			if (createmode === 'false' && documentID) {
				if (selectedFile !== null && selectedFile?.length > 0) {
					selectedFile.forEach(async (file, index) => {
						const resp = await addCKattachmentEsignAPI(file.docId, mapPayload);

						if (selectedFile?.length - 1 === index) {
							for (const [index, serverPayload] of payload.entries()) {
								const typeString = serverPayload.dataUrl.split(';')[0];
								const attachment = {
									type: serverPayload.type,
									typeString,
									dataUrl: serverPayload.dataUrl,
									name: serverPayload.name,
									id: resp.attachmentId[index],
									enableDelete: true
								};
								dispatch(addCkAttachments(attachment));
								dispatch(addEsignAttachments(attachment));
							}
						}
					});
				} else {
					const resp = await addCKattachmentEsignAPI(documentID, mapPayload);
					for (const [index, serverPayload] of payload.entries()) {
						const typeString = serverPayload.dataUrl.split(';')[0];
						const attachment = {
							type: serverPayload.type,
							typeString,
							dataUrl: serverPayload.dataUrl,
							name: serverPayload.name,
							id: resp.attachmentId[index],
							enableDelete: true
						};
						dispatch(addCkAttachments(attachment));
						dispatch(addEsignAttachments(attachment));
					}
				}
			}
		} catch (error) {
			return error;
		}
	};

	return (
		<Box width={'100%'} mt={1} pb={4}>
			<PreviewUploadDocument
				openPDF={openPDF}
				setOpenPDF={setOpenPDF}
				thumbFlag={false}
				thumbnailContent={{ templateHtml: '' }}
			/>

			<div className={isMobile ? 'semiBold14' : 'semiBold5'}>Attachments</div>
			<div
				className={isMobile ? 'medium6' : 'medium4'}
				style={{
					color: '#8E8E8E',
					marginTop: theme.spacing(2)
				}}
			>
				Upload files to provide your customer additional information about
				document
			</div>
			<Box mt={isMobile ? 2 : 5} width={'100%'}>
				<div
					className={isMobile ? 'semiBold14' : 'semiBold6'}
					style={{
						color: '#8E8E8E'
					}}
				>
					Attached documents
				</div>
				<Box width={'100%'} mt={1} rowGap={1.5}>
					{attachedfiles.map((file) => (
						<DocumentNameWrapper
							file={file}
							key={file.id}
							ckattchment
							isMobile={isMobile}
							documentName={file.name}
							setOpenPDF={() => setOpenPDF(!openPDF)}
							setSelectedFile={handleOpenContent}
							width='100%'
							setErrorMessage={setErrorMessage}
							setDropzoneEnabled={setDropzoneEnabled}
							showDownloadOptions={false}
						/>
					))}
				</Box>
			</Box>
			<Box height={isMobile ? 150 : 200} mt={4}>
				<CustomUpload
					handleAttachmentSave={handleAttachmentSave}
					isClicked={false}
					dropzoneHeight={'100%'}
					acceptedFileTypes={acceptedFileTypes}
					attachedfiles={attachedfiles}
					maxFileSize={maxFileSize}
					setDropzoneEnabled={setDropzoneEnabled}
					dropzoneEnabled={dropzoneEnabled}
					errorMessage={errorMessage}
					setErrorMessage={setErrorMessage}
				/>
				<canvas ref={canvasRef} style={{ display: 'none' }} />
			</Box>
		</Box>
	);
}

export default CKEditorAttachments;
